export default "__VITE_ASSET__CsqDBD8p__"